import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import MarathonAnswer from "@jumbo/Dashboards/Tests/MarathonTicketListContainer/MarathonAnswer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.marathonEveventsPage"} />, link: "/marathonDanie" },
  { label: <IntlMessages id={"pages.answerPage"} />, isActive: true },
];

const MarathonAnswerPage = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.answerPage" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <MarathonAnswer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default MarathonAnswerPage;